import { ColumnDef } from "@tanstack/react-table";
import { ClientPublicWithUsers } from "@/client-admin";
import { DataTableColumnHeader } from "@/components/ClientsheetTable/data-table-column-header.tsx";
import { EditClientDialog } from "./EditClientDialog.tsx";

export const columns: ColumnDef<ClientPublicWithUsers>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="ID" />
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: "client_code",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Client Code" />
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: "client_name",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Client Name" />
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: "number_of_users",
    enableSorting: true,
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Number users" />
      </div>
    ),
    cell: ({ row }) => {
      const users: ClientPublicWithUsers["users"] = row.getValue("users");
      return users.length;
    },
    sortingFn: (rowA, rowB) => {
      const usersA: ClientPublicWithUsers["users"] = rowA.getValue("users");
      const usersB: ClientPublicWithUsers["users"] = rowB.getValue("users");
      return usersA.length - usersB.length;
    },
  },
  {
    accessorKey: "users",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Users" />
      </div>
    ),
    cell: ({ row }) => {
      const users: ClientPublicWithUsers["users"] = row.getValue("users");
      return users.map((user) => user.email).join(", ");
    },
  },
  {
    accessorKey: "edit",
    header: ({ column }) => (
      <div className="flex items-center justify-center">
        <DataTableColumnHeader column={column} title="Edit" />
      </div>
    ),
    cell: ({ row }) => {
      const clientId = row.getValue("id");

      if (!clientId || typeof clientId !== "number") {
        throw new Error(`Client ID is not a number: ${clientId}`);
      }

      return (
        <EditClientDialog
          clientId={clientId}
          clientCode={row.getValue("client_code")}
          clientName={row.getValue("client_name")}
        />
      );
    },
  },
];
